import { compact } from 'lodash';
import { useMemo } from 'react';

import {
   AlignItems,
   createDynamicColumnsWidth,
   InteractiveTable,
   InteractiveTableColumnConfiguration,
   JustifyContent,
} from '@dreryk/react-components';

import { GroupSessionsPractitionerValue } from '../GroupSessionsPractitionersField.types';
import { translationKeys } from '../../../../translations';

import { ReceptionServicePractitionerDisplayNameCell } from './cells/ReceptionServicePractitionerDisplayNameCell';
import { ReceptionServicePractitionerSpecialtiesCell } from './cells/ReceptionServicePractitionerSpecialtiesCell';

export const useGroupSessionsPractitionersInteractiveTableColumnConfigurationOptions = (): InteractiveTableColumnConfiguration<GroupSessionsPractitionerValue>[] => {
   return useMemo((): InteractiveTableColumnConfiguration<GroupSessionsPractitionerValue>[] => {
      const columnWidths = createDynamicColumnsWidth({
         id: '0px',
         displayName: '50%',
         specialties: '50%',
         options: '24px',
      });

      return compact([
         {
            name: 'id',
            width: columnWidths.id,
            renderer: ({ bean, index }) => {
               return (
                  <InteractiveTable.ControllerCell testId={'id'} name={'id'} index={index} defaultValue={bean.id} />
               );
            },
            hidden: true,
         },
         {
            name: 'displayName',
            label: translationKeys.displayName,
            width: columnWidths.displayName,
            justifyContent: JustifyContent.START,
            alignItems: AlignItems.CENTER,
            renderer: ({ bean, index }) => {
               return (
                  <ReceptionServicePractitionerDisplayNameCell
                     testId={'displayName'}
                     name={'displayName'}
                     index={index}
                     defaultValue={bean.displayName}
                  />
               );
            },
         },
         {
            name: 'specialties',
            width: columnWidths.specialties,
            justifyContent: JustifyContent.START,
            alignItems: AlignItems.CENTER,
            label: translationKeys.specialties,
            renderer: ({ bean, index }) => {
               return (
                  <ReceptionServicePractitionerSpecialtiesCell
                     testId={'specialties'}
                     name={'specialties'}
                     index={index}
                     defaultValue={bean.specialties}
                  />
               );
            },
         },

         {
            name: 'options',
            width: columnWidths.options,
            renderer: ({ index }) => {
               return <InteractiveTable.DeleteRowCell index={index} />;
            },
         },
      ]);
   }, []);
};
